export const RELEASE = {
  page: 'release-page',
  fullscreenButton: 'fullscreen-button',
  lightsButton: 'lights-toggle-button',
  timerButton: 'timer-toggle-button',
  fadeButton: 'fade-toggle-button',
  liveBadge: 'live-listener-badge',
  liveCount: 'live-listener-count',
  heroTitle: 'release-hero-title',
  playButton: 'play-pause-button',
  prevButton: 'prev-track-button',
  nextButton: 'next-track-button',
  seekBar: 'seek-bar',
  spotifyLink: 'save-spotify-link',
  ytMusicLink: 'save-ytmusic-link',
  nowTitle: 'now-playing-title',
  nowArtist: 'now-playing-artist',
  consentBanner: 'consent-banner',
  consentAccept: 'consent-accept-button',
  consentDecline: 'consent-decline-button',
};
